import { StyleSheet, View } from 'react-native';

export default function LaserFlow() {
  return (
    <View pointerEvents="none" style={s.wrap}>
      <View style={s.a} />
      <View style={s.b} />
    </View>
  );
}

const s = StyleSheet.create({
  wrap: { ...StyleSheet.absoluteFillObject, overflow: 'hidden' },
  a: { position: 'absolute', width: 2, height: '160%', backgroundColor: '#7C3AEDAA', transform: [{ rotate: '35deg' }], right: '35%', top: '-20%' },
  b: { position: 'absolute', width: 2, height: '140%', backgroundColor: '#22D3EE88', transform: [{ rotate: '-25deg' }], left: '28%', top: '-10%' },
});
